<h2 class="calculator__header">Distance Calculator</h2>
<div class="calculator__content">
  <div class="calculator__containerLeft">
    Distance From:
    <br>
    <input id="DistanceFrom" class="calculator__inputs" type="text" placeholder="Identifier" (blur)="onBlurFromIdent()">
    <br>
    <div class="calculator__name"
         *ngIf="fromAirport && !showFromBlank; else fromPlaceholder">{{fromAirport.shortName}}</div>
  </div>
  <div class="calculator__containerRight">
    Distance To:
    <br>
    <input id="DistanceTo" class="calculator__inputs" type="text" value="{{airport.identifier}}" (blur)="onBlurToIdent()">
    <br>
    <div class="calculator__name" *ngIf="toAirport && !showToBlank; else toPlaceholder">{{toAirport.shortName}}</div>
  </div>
  <br>
  <div class="calculator__calculation">
    <button mat-button class="overview__action aopa-mat-btn aopa-mat-btn--filled"
            (click)="calculateDistance()" *ngIf="!showCalculation">Get Distance
    </button>
    <div *ngIf="toAirport && fromAirport && showCalculation">Distance: {{distance}} nm {{direction}}</div>
    <div *ngIf="showCalculation">
      <button mat-button class="calculator__reset" type="reset" (click)="reset()">Reset</button>
    </div>
    <br>
    <a mat-button (click)="planFlightClick()"
       class="overview__action aopa-mat-btn aopa-mat-btn--filled" target="_blank">
      Plan Flight
    </a>
  </div>
</div>

<ng-template #toPlaceholder>
  <div class="calculator__name" *ngIf="showToProcessing; else toInvalidPlaceholder">Loading...</div>
</ng-template>
<ng-template #toInvalidPlaceholder>
  <div class="calculator__name" *ngIf="!showToBlank">Invalid identifier.</div>
</ng-template>
<ng-template #fromPlaceholder>
  <div class="calculator__name" *ngIf="showFromProcessing; else fromInvalidPlaceholder">Loading...</div>
</ng-template>
<ng-template #fromInvalidPlaceholder>
  <div class="calculator__name" *ngIf="!showFromBlank">Invalid identifier.</div>
</ng-template>
